import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  width: 100%;
  height: 90px;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 15px 0px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  flex-direction: row;
`;

export const Title = styled.div`
  font-size: 14px;
  color: #000FFF;
  font-weight: bold;
  padding-bottom: 10px;
`;


export const Left = styled.div`
  display:flex;
  flex-direction: column;
  padding-left: 5px;
  width: 40%;
`

export const Middle = styled.div`
  display:flex;
  flex-direction: column;
  @media (max-width: 324px){
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
`

export const Right = styled.div`
  display:flex;
  flex-direction: column;
  @media (max-width: 324px){
    align-items: flex-end;
  }
`

export const Details = styled.div`
  padding: 0px 12px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color ? "#c9c9c9" : "#000FFF" };
  color: #FFF;
  font-size: 10px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  cursor: pointer;

  @media (max-width: 324px){
    height: 10rem;
  }
`


export const IconInformationBlue = {
  width: 22,
  height: 22,
  marginLeft: 5,
};

export const IconPix = {
  width: 22,
  height: 22,
  marginLeft: 5,
};

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const ImageDiv = styled.div`
  padding: 0 5px;
`